import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "../../lib/api";
import { PageHeader } from "../../components/Shared";
import { AdminTabs, Kpi, ActivityList, fmtBytes } from "./shared";

export default function AdminOverview() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setD(r.data)).catch((e) => toast.error(errorMessage(e))); }, []);
  if (!d) return <p className="text-sm text-slate-500">Loading…</p>;
  const c = d.customers;
  return (
    <div data-testid="admin-overview">
      <PageHeader title="Super Admin" subtitle="Supplivo platform — customers, approvals and usage." />
      <AdminTabs pending={d.pending_applications} />
      {d.pending_applications > 0 && <div className="mb-4 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm font-semibold text-amber-900" data-testid="new-application-banner">New Customer Application{d.pending_applications > 1 ? "s" : ""} — {d.pending_applications} waiting for your approval.</div>}
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <Kpi label="Pending applications" value={d.pending_applications} accent to="/admin/applications" testId="kpi-pending" />
        <Kpi label="Total customers" value={c.total} sub={`${c.active} active · ${c.trial} trial`} to="/admin/customers" testId="kpi-customers" />
        <Kpi label="Past due / suspended" value={`${c.past_due} / ${c.suspended}`} sub={`${c.cancelled} cancelled`} testId="kpi-risk" />
        <Kpi label="Restaurants · users" value={`${d.restaurants} · ${d.users}`} testId="kpi-tenants" />
        <Kpi label="Invoices" value={d.invoices} testId="kpi-invoices" />
        <Kpi label="Orders" value={d.orders} testId="kpi-orders" />
        <Kpi label="Storage used" value={fmtBytes(d.storage_bytes)} sub={d.photo_bytes_saved ? `${fmtBytes(d.photo_bytes_saved)} saved by photo optimisation · ${d.uncropped_fallbacks} uncropped` : `${d.storage_objects ?? "—"} objects (deduplicated)`} testId="kpi-storage" />
        <Kpi label="AI / OCR usage" value={d.ai.calls} sub={`$${d.ai.cost_usd} total`} to="/admin/ai-usage" testId="kpi-ai" />
      </div>
      <div className="mt-6 rounded-xl border border-slate-200 bg-white p-4"><h2 className="mb-2 text-base font-semibold">Recent customer activity</h2><ActivityList rows={d.recent_activity} testId="recent-activity" /></div>
    </div>
  );
}
